/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2021-10-09 17:47:15
 * @LastEditTime: 2022-03-21 18:02:51
 * @LastEditors: Yandong Hu
 * @Description:
 */

import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import headerService from "../../services/header.service";
// import loadingService from "../../services/loading.service";
import mblockService from "../../services/mblock.service";
import "./mblock.scss";

export const MblockIDE = () => {
  const setHeaderTextState = useSetRecoilState(headerService.HeaderTextState);
  // const setLoadingTextState = useSetRecoilState(loadingService.LoadingTextState);
  // const setLoadingVisibleState = useSetRecoilState(loadingService.LoadingVisibleState);
  const initMblockIde = async () => {
    await mblockService.initIDE();
    mblockService.renderIDE("#mblock-ide");
    mblockService.setLogin(true);
    // mblockService.onLoadingProject((percent: number) => {
    // if(percent < 1) {
    //   setLoadingVisibleState(true);
    //   setLoadingTextState(`正在加载${percent * 100}%`);
    // }
    // if(percent === 1) {
    //   setLoadingTextState(`正在完成100%`);
    //   setTimeout(() => {
    //     setLoadingVisibleState(false);
    //   }, 500);
    // }
    // });
    mblockService.onLoadedProject((value: string) => {
      value && setHeaderTextState(value);
    });
    mblockService.getAccesstoken();
  };
  useEffect(() => {
    initMblockIde();
  });
  return <div id="mblock-ide" className="root-containers"></div>;
};
